var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H67C68.933 0.5 70.5 2.067 70.5 4V67C70.5 68.933 68.933 70.5 67 70.5H4C2.067 70.5 0.5 68.933 0.5 67V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "#146EB4",
    fillOpacity: 0.1,
    stroke: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 56H10.5C10.2239 56 10 56.2239 10 56.5C10 56.7761 10.2239 57 10.5 57H61.5C61.7761 57 62 56.7761 62 56.5C62 56.2239 61.7761 56 61.5 56Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16.334H17C15.3431 16.334 14 17.6473 14 19.2673V42.734C14 44.354 15.3431 45.6673 17 45.6673H35C36.6569 45.6673 38 44.354 38 42.734V25.134L29 16.334Z",
    stroke: "#146EB4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16.334V25.134H38",
    stroke: "#146EB4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29.666V39.666",
    stroke: "#146EB4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8891 34.5549L26.0002 29.666L21.1113 34.5549",
    stroke: "#146EB4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFile);
export default __webpack_public_path__ + "static/media/active-file.1e4ad69e095a6c03943c26a9876da2ed.svg";
export { ForwardRef as ReactComponent };